<div class="dashboard-module-item-dialog" fxLayout="row" fxFlex="100">
  <div
    fxLayout="column"
    fxFlex="100"
    [ngClass]="
      selectedStudy
        ? selectedStudy?.type === StudyType.TIIM
          ? 'tiim-material-theme'
          : 'cc-material-theme'
        : 'dashboard-material-theme'
    "
  >
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <dashboard-dialog-title *ngIf="!subType" [title]="'Please choose a module item'"> </dashboard-dialog-title>
      <dashboard-dialog-title
        *ngIf="subType"
        [title]="getModuleItemSubTypeLabel(moduleItemsConfig, type, subType)"
      ></dashboard-dialog-title>
      <mat-divider></mat-divider>
    </div>
    <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="100" fxFlexOffset="20px">
      <mat-dialog-content
        class="dashboard-module-item-dialog__dialog"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between stretch"
        fxFlex="100"
      >
        <div fxFlex="40" fxFlex.lt-md="100">
          <div>
            <mat-form-field appearance="fill" fxFlex="100">
              <mat-label>Module item</mat-label>
              <mat-select
                (selectionChange)="selectModuleItem($event.value)"
                [(value)]="moduleItemSubType"
                [disabled]="selectedModuleItem"
              >
                <mat-select-trigger>
                  <div style="padding-top: 8px">
                    <mat-icon style="vertical-align: middle; margin-right: 16px">{{
                      moduleItemSubType?.icon
                    }}</mat-icon>
                    {{ moduleItemSubType?.label }}
                  </div>
                </mat-select-trigger>
                <mat-option *ngFor="let moduleItem of availableModuleItems" [value]="moduleItem">
                  <mat-icon>{{ moduleItem?.icon }}</mat-icon>
                  {{ moduleItem?.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <dashboard-statement *ngIf="subType === ModuleItemAvailableSubType.STATEMENT" [dialogData]="data">
            </dashboard-statement>
            <dashboard-number-inputs
              *ngIf="
                subType === ModuleItemAvailableSubType.INPUT ||
                (subType === ModuleItemAvailableSubType.DROPDOWN && type === ModuleItemAvailableType.NUMBER) ||
                subType === ModuleItemAvailableSubType.SLIDER ||
                subType === ModuleItemAvailableSubType.SINGLE_CHOICE
              "
              [dialogData]="data"
            >
            </dashboard-number-inputs>
            <dashboard-dropdown
              *ngIf="subType === ModuleItemAvailableSubType.DROPDOWN && type === ModuleItemAvailableType.TEXT"
              [dialogData]="data"
            >
            </dashboard-dropdown>
            <dashboard-line-inputs
              *ngIf="
                subType === ModuleItemAvailableSubType.SINGLE_LINE || subType === ModuleItemAvailableSubType.MULTI_LINE
              "
              [dialogData]="data"
            >
            </dashboard-line-inputs>
            <dashboard-multiple-choice
              *ngIf="subType === ModuleItemAvailableSubType.MULTIPLE_CHOICE"
              [dialogData]="data"
            >
            </dashboard-multiple-choice>
            <dashboard-yes-no
              *ngIf="
                subType === ModuleItemAvailableSubType.YES_NO || subType === ModuleItemAvailableSubType.YES_NO_OTHER
              "
              [dialogData]="data"
            >
            </dashboard-yes-no>
            <dashboard-likert-scale *ngIf="subType === ModuleItemAvailableSubType.LIKERT" [dialogData]="data">
            </dashboard-likert-scale>
            <dashboard-video-audio *ngIf="subType === ModuleItemAvailableSubType.VIDEO_AUDIO" [dialogData]="data">
            </dashboard-video-audio>
            <dashboard-emotion-quadrant *ngIf="subType === ModuleItemAvailableSubType.QUADRANT" [dialogData]="data">
            </dashboard-emotion-quadrant>
            <dashboard-graph *ngIf="subType === ModuleItemAvailableSubType.GRAPH" [dialogData]="data"></dashboard-graph>
            <dashboard-simple-items
              *ngIf="
                subType === ModuleItemAvailableSubType.IMAGE || subType === ModuleItemAvailableSubType.AUDIO_RECORDING
              "
              [dialogData]="data"
            ></dashboard-simple-items>
            <dashboard-orbits *ngIf="subType === ModuleItemAvailableSubType.ORBITS" [dialogData]="data">
            </dashboard-orbits>
            <dashboard-network *ngIf="subType === ModuleItemAvailableSubType.NETWORK" [dialogData]="data">
            </dashboard-network>
            <dashboard-ivy *ngIf="subType === ModuleItemAvailableSubType.IVY" [dialogData]="data"> </dashboard-ivy>
          </div>
        </div>
        <div fxFlex="60" fxFlex.lt-md="100" fxLayout="row" fxLayoutAlign="center start" fxFlexOffset="50px">
          <mat-tab-group mat-stretch-tabs fxLayout="column" fxFlex="100" fxLayoutGap="50px">
            <mat-tab [label]="MODULE_ITEM_DIALOG_TAB_LABELS.PREVIEW">
              <dashboard-module-item-preview
                [studyType]="selectedStudy?.type"
                [type]="type"
                [subType]="subType"
                [moduleItem]="selectedModuleItem"
                [study]="selectedStudy"
                fxLayout="row"
                fxLayoutAlign="center center"
              >
              </dashboard-module-item-preview>
            </mat-tab>
            <mat-tab [label]="MODULE_ITEM_DIALOG_TAB_LABELS.ROUTING">
              <dashboard-module-item-routing [dialogData]="data"></dashboard-module-item-routing>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-dialog-content>
    </div>
  </div>
</div>
